import { useState, useCallback } from 'react'
import { createContainer } from 'unstated-next'
import { Country, CountryListing } from 'types/model'
import { getCountry } from 'lib/api/pointOfSale'

interface CountryState {
  countries: CountryListing[]
  currentCountry: Country
}

export interface CountryContainer extends CountryState {
  initCountries: (state: CountryState) => void
  selectCountry: (country: string) => Promise<void>
}

const useCountries = () => {
  const [countries, setCountries] = useState<CountryListing[]>([])
  const [currentCountry, setCurrentCountry] = useState<Country>(undefined!)

  const initCountries = useCallback(
    ({ countries, currentCountry }: CountryState) => {
      setCountries(countries)
      setCurrentCountry(currentCountry)
    },
    []
  )

  const selectCountry = useCallback(async (code: string) => {
    const currentCountry = await getCountry(code)
    setCurrentCountry(currentCountry)
  }, [])

  return { countries, currentCountry, initCountries, selectCountry }
}

export default createContainer<CountryContainer>(useCountries)
